export const getArrayWithChangedValue = <T,>(array: T[], newValue: T, index: number) => {
  const newArray = [...array];
  newArray[index] = newValue;
  return newArray;
};
